import { Component, OnInit } from '@angular/core';
import { StatementOfAccountService } from '../services/statementOfAccount.service';
import { StatementOfAccountProperties, SearchStatementOfAccountProperties, PdfStatementOfAccountProperties, ERPCustomerStatementReq } from '../Models/StatementOfAccountProperties';
import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
declare var $;

@Component({
  selector: 'app-statement-of-account',
  templateUrl: './statement-of-account.component.html',
  styleUrls: ['./statement-of-account.component.css']
})
export class StatementOfAccountComponent implements OnInit {
  ledgerList: any[];
  ledgerSearchObj = new ERPCustomerStatementReq();
  ledgerProp = new PdfStatementOfAccountProperties();
  ledgerSearchSubmitted: boolean = false;
  loaderVar: boolean = false;
  /*  dtTrigger: Subject<any> = new Subject();*/
  url_Address: string = "";
  futureDate: string = "";
  minDateRange: string = "";

  constructor(private statementOfAccountService: StatementOfAccountService) { }

  ngOnInit() {
    //this.futureDate = new Date().getDate();

    let newDate = new Date();
    newDate.setDate(newDate.getDate() - 30);
    let maxDateRange = new Date();


    let arrivePipe: DatePipe = new DatePipe('en-US');
    this.minDateRange = arrivePipe.transform(newDate, "yyyy-MM-dd");
    this.futureDate = arrivePipe.transform(maxDateRange, "yyyy-MM-dd");
    console.log(this.minDateRange, this.futureDate);
    //this.LoadLedgerView();
  }
  ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  DateValidationFromDate = (date: any): void => {
    if (date < this.minDateRange) {
      this.ledgerSearchObj.fromDate = this.minDateRange;
    }
    if (date > this.futureDate) {
      this.ledgerSearchObj.fromDate = this.futureDate;
    }

  }
  DateValidationToDate = (date: any): void => {
    if (date < this.minDateRange) {
      this.ledgerSearchObj.toDate = this.minDateRange;
    }
    if (date > this.futureDate) {
      this.ledgerSearchObj.toDate = this.futureDate;
    }

  }
  collapsed = false;
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "var(--first-color-second)", "color": "white", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  onRowPrepared(e) {
    try {
      if (e.rowType == 'data' && e.data.narration == "Opening Balance") {
        e.rowElement.style.fontWeight = "bold";
        //e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      }
      else if (e.rowType == 'data' && e.data.narration == "Total") {
        e.rowElement.style.fontWeight = "bold";
        //e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      }
    }
    catch (ee) {
      //Console.log(ee);
    }
  }

  LoadLedgerView(formData: any) {
    try {
      this.ledgerSearchSubmitted = true;
      if (formData.invalid) {
        return false;
      }
      else {
        this.loaderVar=true;
        this.ledgerList=[];
       // $('#datatable').DataTable().clear();
        this.ledgerSearchObj.customerCode = localStorage.getItem("BackSystemCompanyCustomer");
        // this.statementOfAccountService.getERPUrl().subscribe((data) => {
        this.ledgerSearchObj.backOfficeCompany = localStorage.getItem("BackSystemCompanyId");
        console.log(this.ledgerSearchObj)
        this.statementOfAccountService.getErpJournalLedger(this.ledgerSearchObj).subscribe((data) => {
          this.ledgerList = data;
          this.loaderVar=false;

          // this.dtTrigger.next();
        });
        // })

      

    }
      
      
   
    }
  catch(e) { }
}





PrintLeadger() {
  let doc = new jsPDF('p', 'mm', [305, 375]);
  let imgPath = "./assets/OklogoNew.png";
  var width = doc.internal.pageSize.getWidth();
  doc.addImage(imgPath, 'PNG', 13, 15, 40, 30);

  let accountCode = this.ledgerSearchObj.customerCode;
  //let accountName = this.ledgerSearchObj.accountName;
  //doc.setFontSize(14);
  //doc.setFont("", "", "500");
  //doc.text(`${accountCode} ${accountName}`, width - 15, 20, { align: "right" });

  let printDate = new Date().toLocaleString();
  doc.setFontSize(12);
  doc.setFont("", "", "500");
  doc.text(`Run Time: ${printDate}`, width - 15, 27, { align: "right" });

  let fromDate = this.ledgerSearchObj.fromDate;
  let toDate = this.ledgerSearchObj.toDate;
  doc.setFontSize(15);
  doc.setFont("", "", "500");
  doc.text(`From: ${fromDate}   To: ${toDate}`, width / 2, 40, { align: "center" });

  var bodyData = [];
  this.ledgerList.forEach((el, index, array) => {
    bodyData.push([el.jeDate, el.jeid, el.serviceType, el.ticketNumber, el.pnrNumber, el.jeType, el.narration, el.debit, el.credit, el.balance])
  })
  autoTable(doc, {
    head: [['Date', 'Doc ID', 'Service Type', 'Ticket Number', 'PNR Number', 'Type', 'Narration', 'Debit', 'Credit', 'Blance']],
    headStyles: { fillColor: [167, 171, 191], textColor: [0, 0, 0], halign: "center", fontStyle: "bold" },
    body: bodyData,
    didParseCell: function (data) {
      if ((data.row.index === 0) || (data.row.index === bodyData.length - 1)) {
        data.cell.styles.fontStyle = "bold";
      }

    },
    columnStyles: {
      0: { cellWidth: 23.8, fontSize: 9, valign: 'middle' },
      1: { cellWidth: 27, fontSize: 9, valign: 'middle' },
      2: { cellWidth: 27, fontSize: 9, valign: 'middle' },
      3: { cellWidth: 27, fontSize: 9, valign: 'middle' },
      4: { cellWidth: 27, fontSize: 9, valign: 'middle' },
      5: { cellWidth: 13, fontSize: 9, valign: 'middle' },
      6: { cellWidth: 46, fontSize: 9, valign: 'middle' },
      7: { cellWidth: 30, fontSize: 9, valign: 'middle', halign: 'center' },
      8: { cellWidth: 30, fontSize: 9, valign: 'middle', halign: 'center' },
      9: { cellWidth: 30, fontSize: 9, fontStyle: 'bold', valign: 'middle', halign: 'center' },
    },
    startY: 50,
    theme: 'grid',
  })
  var pageHeight = doc.internal.pageSize.getHeight();
  let pageCount = doc.getNumberOfPages();
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    const footer = `Page ${i} of ${pageCount}`;
    doc.setFontSize(12);
    doc.setFont('', '', 'normal');
    doc.text(footer, width / 2 - (doc.getTextWidth(footer) / 2), pageHeight - 7);

  }
  doc.save(`StatementOfAccount_${accountCode}`);
}



  //onblur(e) {

  //  $("#btnSearch").attr("disabled", "disabled");
  //  if ((this.ledgerSearchObj.fromDate != null && this.ledgerSearchObj.fromDate != "" && this.ledgerSearchObj.fromDate != undefined)
  //    && this.ledgerSearchObj.toDate != null && this.ledgerSearchObj.toDate != "" && this.ledgerSearchObj.toDate != undefined) {
  //    if (e.target.id == "fromDate") {
  //      // $("#btnSearch").attr("disabled", "disabled");
  //      if (this.ledgerSearchObj.fromDate < this.minDate) {
  //        $("#lblerrors").show();
  //        document.getElementById("lblerrors").innerHTML = "Please Enter Valid Date(s)";
  //        $("#lblerrors").delay(3000).hide(100);
  //      }
  //      else if (this.ledgerSearchObj.fromDate > this.futureDate) {
  //        $("#lblerrors").show();
  //        document.getElementById("lblerrors").innerHTML = "Please Enter Valid Date(s)";
  //        $("#lblerrors").delay(3000).hide(100);
  //      }
  //      //else {
  //      //  $("#btnSearch").removeAttr("disabled");
  //      //}

  //    }
  //    else if (e.target.id == "toDate") {
  //      // $("#btnSearch").attr("disabled", "disabled");
  //      if (this.ledgerSearchObj.toDate < this.minDate) {
  //        $("#lblerrors").show();
  //        document.getElementById("lblerrors").innerHTML = "Please Enter Valid Dates(s)";
  //        $("#lblerrors").delay(3000).hide(100);
  //      }
  //      else if (this.ledgerSearchObj.toDate > this.futureDate) {
  //        $("#lblerrors").show();
  //        document.getElementById("lblerrors").innerHTML = "Please Enter Valid Date(s)";
  //        $("#lblerrors").delay(3000).hide(100);
  //      }
  //      //else {
  //      //  $("#btnSearch").removeAttr("disabled");
  //      //}
  //    }
  //    if (this.ledgerSearchObj.fromDate >= this.minDate && this.ledgerSearchObj.fromDate <= this.futureDate
  //      && this.ledgerSearchObj.toDate >= this.minDate && this.ledgerSearchObj.toDate <= this.futureDate) {
  //      $("#btnSearch").removeAttr("disabled");
  //    }
  //  }
  //}


}
